import { Injectable } from '@angular/core';
import { Router, NavigationEnd, UrlTree, NavigationCancel } from '@angular/router';
import { filter } from 'rxjs/operators';
import { PageRoute } from 'src/app/data-models/history-manager/page-route-model';
import { ConfigService } from '../config/config.service';
import { Subscription } from 'rxjs';
import { CommonService } from '../common/common.service';
import { AppNotification } from 'src/app/data-models/common/app-notification.model';

@Injectable({
  providedIn: 'root'
})
export class HistoryManager {
	history: Array<PageRoute>;
	currentRoute: PageRoute;
	backRoute: PageRoute;
	subscription: Subscription;

	constructor(private router: Router, private configService: ConfigService, private commonService: CommonService) {
		this.history = [];
		this.router.events
			.pipe(filter(event => event instanceof NavigationEnd))
			.subscribe((event: NavigationEnd | NavigationCancel) => {
				if (event instanceof NavigationEnd) {
					this.commonService.sendNotification('routerChanged', event.urlAfterRedirects);

					if (this.backRoute && this.backRoute.finalPath.split('?')[0] === event.urlAfterRedirects) {
						this.currentRoute = this.backRoute;
						this.backRoute = null;
						return;
					}

					const currentNavigation = this.router.getCurrentNavigation();
					const previousNavigation = currentNavigation ? currentNavigation.previousNavigation : null;
					const skipPreviousUrl = previousNavigation && previousNavigation.extras && previousNavigation.extras.skipLocationChange;
					const replaceUrl = currentNavigation && currentNavigation.extras && currentNavigation.extras.replaceUrl;
					let newPage = new PageRoute(event.url, event.urlAfterRedirects);

					if (this.history.length === 0 && !this.configService.isBelongToDefaultRoute(newPage.finalPath) && newPage.finalPath !== '/') {
						this.history.push(new PageRoute(this.configService.defaultRoute.toString()));
					}

					if (this.currentRoute && !skipPreviousUrl && !replaceUrl) {
						this.history.push(this.currentRoute);
					}

					this.currentRoute = newPage;
				} else if (event instanceof NavigationCancel && this.backRoute && event.url === this.backRoute.finalPath.split('?')[0]) {
					this.goBack();
				}
			});

		this.subscription = this.commonService.notification.subscribe((notification: AppNotification) => {
			this.onNotification(notification);
		});
	}

	goBack() {
		this.backRoute = this.history.pop();
		if (this.backRoute) {
			this.router.navigateByUrl(this.backRoute.finalPath.split('?')[0]);
		} else {
			this.router.navigateByUrl(this.configService.defaultRoute.toString());
		}
	}

	private changeDefaultRoute(currentDefaultRoute: UrlTree) {
		let newDefaultUrl = '/';
		if (currentDefaultRoute) {
			newDefaultUrl = currentDefaultRoute.toString();
		}
		this.modifyAt(new PageRoute(newDefaultUrl), 0);
	}

	private modifyAt(newItem: PageRoute, index: number): boolean {
		if (index >= this.history.length || index < 0) return false;
		this.history[index] = newItem;
		return true;
	}

	private onNotification(notification: AppNotification) {
		if (notification) {
			switch (notification.type) {
				case 'default-route-changed':
					this.changeDefaultRoute(notification.payload);
					break;
				default:
					break;
			}
		}
	}
}
